import React from "react";
import Link from "../../../Link";

export default class TrudatPopularityBar extends React.Component {
  render() {
    var style = {
      width: this.props.data.pr + "%"
    };

    return (
      <Link
        to={this.props.data.url}
        className="hp__box__popular-bar"
        style={style}
      >
        <span className="hp__box__popular-bar-title">
          {" "}
          {this.props.data.title}{" "}
        </span>
        <span className="hp__box__popular__bar-comment-position">
          <span className="hp__box__popular__bar-comment-position-wrapper">
            <img alt="" src={window.STATIC_DOMAIN + "/gfx/trudat/chat_bubble.png"} />
            <span className="hp__box__popular__bar-comment-value">
              {" "}
              {this.props.data.tr}{" "}
            </span>
          </span>
        </span>
      </Link>
    );
  }
}
